
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { Comment, ModerationEnum } from "@/types";

@Component
export default class DisplayComments extends Vue {
  @Prop() comments!: Comment[];

  @Prop() loading!: boolean;

  isLoading: boolean = false;

  moderationEnum = ModerationEnum;

  selected: any = [];

  pagination: any = {
    sortBy: "createdAt"
  };

  headers: any = [
    { text: "Texte", value: "text" },
    { text: "Author", value: "author" },
    { text: "Reco", value: "tip" },
    { text: "Moderation", value: "moderation" },
    { text: "Date de création", value: "createdAt" },
    { text: "Actions", value: "action", sortable: false }
  ];

  search: String = "";

  @Watch("loading", { immediate: true })
  handleLoadingChange(value: boolean) {
    this.isLoading = value;
  }

  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.comments.slice();
  }

  changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }
}
